import { FC } from 'react';
import { EventCategory } from '../../hooks/useEventTracking';

type EventTrackingProps = {
  /** EventCategory from useEventTracking hook */
  eventCategory: EventCategory;
  /** isLayer from useEventTracking hook */
  isLayer?: boolean;
  /** if you need to trigger the same event twice, change this number */
  triggerId?: number;
};

/*
 *
 *
 BI-1756 No Argus tracking anymore
 *
 *
 */

export const EventTracking: FC<EventTrackingProps> = () => {
  return null;
};

export default EventTracking;
